import { ArrowUpRight, MapPin, Mail, Linkedin } from "lucide-react";
import { Reveal, MaskLine } from "@/components/motion";
import { CONTACT } from "@/data/projects";

export default function Contact() {
  return (
    <section id="contact" className="border-t border-hairline" data-testid="contact-section">
      <div className="mx-auto max-w-[1400px] px-6 py-28 sm:px-10 sm:py-36">
        <Reveal>
          <p className="overline-label">Open to the right opportunity</p>
        </Reveal>
        <h2 className="mt-6 font-serif font-light leading-[1.0] tracking-tight text-ink text-5xl sm:text-7xl" data-testid="contact-headline">
          <MaskLine delay={0.1}>Let's talk</MaskLine>
          <MaskLine delay={0.22} className="italic text-moss">hospitality.</MaskLine>
        </h2>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-smoke">
            I'm exploring opportunities in hotel investment, feasibility, development, advisory and commercial strategy.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-14 grid grid-cols-1 border-l border-t border-hairline sm:grid-cols-3">
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="contact-email"
              className="group border-b border-r border-hairline p-7 transition-colors duration-300 hover:bg-stone2"
            >
              <Mail size={16} strokeWidth={1.25} className="text-moss" />
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-fog">Email</p>
              <p className="mt-1.5 break-all text-sm font-medium text-ink">{CONTACT.email}</p>
            </a>
            <a
              href={CONTACT.linkedin}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-linkedin"
              className="group border-b border-r border-hairline p-7 transition-colors duration-300 hover:bg-stone2"
            >
              <Linkedin size={16} strokeWidth={1.25} className="text-moss" />
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-fog">LinkedIn</p>
              <p className="mt-1.5 break-all text-sm font-medium text-ink">{CONTACT.linkedin}</p>
            </a>
            <div className="border-b border-r border-hairline p-7" data-testid="contact-location">
              <MapPin size={16} strokeWidth={1.25} className="text-moss" />
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-fog">Location</p>
              <p className="mt-1.5 text-sm font-medium text-ink">{CONTACT.location}</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <a
            href={CONTACT.cv}
            download
            data-testid="contact-download-cv"
            className="group mt-10 inline-flex items-center gap-2 bg-ink px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.18em] text-paper transition-colors duration-300 hover:bg-moss"
          >
            Download CV
            <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
